import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {User} from '../../../graphql/auth';
import {gqlUser} from '../getUser.api';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';

export interface UpdateSelfVars {
    data: {
        id: number,
        first_name?: string
        last_name?: string
        email?: string
        password?: string
        email_opt_out?: boolean,
        sms_opt_out?: boolean,
        cellphone?: string,
        cellphone_code?: string,
        email_verified?: boolean
    };
}

interface UpdateSelfData {
    __typename?: string,
    updateSelf: User
}

export const UPDATE_SELF_MUTATION = gql`
    mutation updateSelf($data: UpdateSelfInput!) {
        updateSelf(data: $data) {
            ${gqlUser}
        }
    }
`;

export const updateSelf = () => useMutation<UpdateSelfData, UpdateSelfVars>(
    UPDATE_SELF_MUTATION,
    {
        update: updateCacheByType('User'),
    }
);

export default updateSelf;